module.exports = __webpack_public_path__ + "static/media/sdump-busd.846628a7.png";